import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getBooks } from '../../books';

import './index.scss';

interface Props {
  index: number;
}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-books-item');

const Item: React.FC<Enhanced> = ({ t, index }) => {
  const book = getBooks(t)[index];

  return (
    <a href={book.downloadLink} target="_blank" className={b({ color: book.titleHoverColor })}>
      <div className={b('wrapper')}>
        <figure className={b('figure')}>
          <img className={b('img')} src={book.imgUrl} alt={book.title} />
          <figcaption title={book.title} className={b('title')}>
            {book.title}
          </figcaption>
          <div className={b('link')}>{t('Download PDF')}...</div>
        </figure>
      </div>
    </a>
  );
};

export default translate(Item);
